const translateMain = {
  ingles: {
    welcome: 'Welcome',
    partner: 'Partner',
    assinar: 'Subscribe',
    freeTour: 'Free Tour',
    modelos: 'Models',
    videos: 'Videos',
    lives: 'Lives',    
    blog: 'Blog',
    colunas: 'Articles',
    ecards: 'eCards',
    bellacloud: 'Bella Cloud',
    minhaConta: 'My Account',
    contato: 'Contact',
    sobre: 'About Us',
    privacidade: 'Privacy Policy',
    cancelamento: 'Cancellation Policy',
    afiliados: 'Affiliate Program',
    parceiro: 'Partner Area',
    publicidade: 'Advertising',
    imprensa: 'Press',
    copia: 'All rights reserved',
    declaracao:
      'Bella Club declares that all models on the site were over 18 years of age on the day they were photographed. By entering this site, you swear that you are of legal age in your area to view adult material and that you wish to view it.',
    saudacao: 'Welcome',
    edicoes: 'Editions',
    news: "Receive Bella's news",
    newsDescription: 'Sign up and get the most delicious newsletter on the internet',
    email: 'Enter your email',
    emailDescription:
      'By signing up, you agree to receive emails from Bella Club and accept our web terms of use and privacy and cookie policy.',

    entrar: 'Login',
    sair: 'Logout',
    footerDescription:
      'Bella Club is a portal that brings you closer to the world of models through exclusive photos and videos, with high quality and good taste. You will also find columns on topics such as health, sports, fashion, relationships and erotism.',
    btnSeeMore: 'See More',

    // new front
    hello: 'Hello',
    subscribe: 'SUBSCRIBE TO BELLA NOW',
    myAccount: 'My Account',
    contactUs: 'Contact Us',
    modalErrorTitle: 'Newsletter Error',
    modalSuccessTitle: 'Success Subscription',
    modalErrorDescription: 'Check the error:',
    buttomImageCardPrincipal: 'Show now',
    goToBlog: 'Go to blog',
    titleBlog: 'Bella Club Blog',
    subtitleBlog: 'Your daily guide with the best of the male universe: health, tips, gastronomy, culture, technology, motorsport, lifestyle, relationships, the muses of the moment and more.',
    moreBlog: 'Read more',
    commentsBlog: 'comments',
    newsletterMessage:
      'Register your email and receive the most delicious newsletter on the internet.',
    inputEmail: 'Enter your email',
    titleColumns: 'Columns',
    subtitleColumns: 'Discover the most extraordinary things life has to offer men with our columnists and opinion makers.',
    descriptionColumns:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit donec et turpis tristique, porttitor augue in onsectetur adipiscing.',
    seeAllColumns: 'See all columns',
    readMore: 'Read more columns',    
  },
  portugues: {
    welcome: 'Bem-vindo',
    partner: 'Parceiro',
    assinar: 'assinar',
    freeTour: 'Free Tour',
    modelos: 'Modelos',
    videos: 'Vídeos',
    lives: 'Lives',    
    blog: 'Blog',
    colunas: 'Colunas',
    ecards: 'ecards',
    bellacloud: 'Bella Cloud',
    minhaConta: 'Minha conta',
    contato: 'Contato',
    sobre: 'Sobre o Bella',
    privacidade: 'Politica de Privacidade',
    cancelamento: 'Política de Cancelamento',
    afiliados: 'Programa Afiliados',
    parceiro: 'Área do parceiro',
    publicidade: 'Publicidade',
    imprensa: 'Imprensa',
    copia: 'Todos os direitos reservados',
    saudacao: 'Bem-vindo',
    edicoes: 'Edições',
    news: 'Receba as novidades do Bella',
    newsDescription: 'Cadastre-se e receba a mais deliciosa newsletter da internet',
    email: 'Insira seu e-mail',
    emailDescription:
      'Ao se cadastrar, você concorda em receber e-mails da Bella Club e aceita nossos termos de uso da web e política de privacidade e cookies.',
    declaracao:
      'O Bella da Semana declara que todas as modelos do site tinham mais de 18 anos de idade no dia em que foram fotografadas. Ao entrar neste site, você jura que é maior de idade em sua área para visualizar material adulto e que deseja visualizá-lo.',
    entrar: 'Entrar',
    sair: 'Sair',
    footerDescription:
      'O Bella da Semana é um portal que deixa você mais próximo do mundo das modelos através de fotografias e vídeos exclusivos, de alta qualidade e bom gosto. Você também encontra colunas sobre temas como saúde, esportes, moda, relacionamentos e erotismo.',
    btnSeeMore: 'Saiba mais',

    // new front
    hello: 'Olá',
    subscribe: 'ASSINE AGORA O BELLA',
    myAccount: 'Acessar Minha Conta',
    contactUs: 'Fale Conosco',
    modalErrorTitle: 'Erro na Inscrição',
    modalSuccessTitle: 'Inscrição Realizada',
    modalErrorDescription: 'Verifique o erro:',
    buttomImageCardPrincipal: 'Confira agora o ensaio',
    goToBlog: 'Acesse o blog',
    titleBlog: 'Blog do Bella',
    subtitleBlog: 'Seu guia diário com o melhor do universo masculino: saúde, dicas, gastronomia, cultura, tecnologia, automobilismo, lifestyle, relacionamento, as musas do momento e mais.',
    moreBlog: 'Leia mais',
    commentsBlog: 'comentários',
    newsletterMessage: 'Cadastre o seu email e receba a mais deliciosa newsletter da internet.',
    inputEmail: 'Insira seu email',
    titleColumns: 'Colunas',
    subtitleColumns: 'Descubra o que a vida tem de mais extraordinário para oferecer aos homens com os nossos colunistas e formadores de opinião.',
    seeAllColumns: 'Veja todas colunas',
    readMore: 'Carregar mais colunas',    
  }
}

export default translateMain
